webpackJsonp([39016889708548],{

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.SolutionTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _theme = __webpack_require__(6);
	
	var _Content = __webpack_require__(35);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PageDetailContainer = __webpack_require__(46);
	
	var _PageDetailContainer2 = _interopRequireDefault(_PageDetailContainer);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _PullQuote = __webpack_require__(108);
	
	var _PullQuote2 = _interopRequireDefault(_PullQuote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolutionTemplate = exports.SolutionTemplate = function SolutionTemplate(_ref) {
	    var content = _ref.content,
	        contentComponent = _ref.contentComponent,
	        title = _ref.title,
	        intro = _ref.intro,
	        helmet = _ref.helmet;
	
	    var PostContent = contentComponent || _Content.HTMLContent;
	
	    return _react2.default.createElement(
	        _PageDetailContainer2.default,
	        null,
	        helmet || "",
	        _react2.default.createElement(
	            _rlaComponents.Row,
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Column,
	                null,
	                _react2.default.createElement(
	                    _HeaderBlock2.default,
	                    { textAlign: "left", baseColor: _theme.colors.background },
	                    title
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _rlaComponents.Row,
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Column,
	                null,
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    intro
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _rlaComponents.Row,
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Column,
	                null,
	                _react2.default.createElement(PostContent, { content: content })
	            )
	        )
	    );
	};
	
	exports.default = function (_ref2) {
	    var data = _ref2.data;
	
	    //console.log(data);
	    var solution = data.markdownRemark;
	
	    return _react2.default.createElement(SolutionTemplate, {
	        description: solution.frontmatter.description,
	        helmet: _react2.default.createElement(_reactHelmet2.default, {
	            title: "Our Solution | " + solution.frontmatter.title
	        }),
	        title: solution.frontmatter.title,
	        content: solution.html,
	        intro: solution.frontmatter.intro
	    });
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-solutions-js-2b1f1323cfa1ea924912.js